import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'PhoneAreaCode';
const ENDPOINT = `/phone-area-codes/`;

@Injectable({
    providedIn: 'root'
})
export class PhoneAreaCodeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
